import { render, staticRenderFns } from "./AddEditDocument.vue?vue&type=template&id=0c8c77aa&scoped=true&"
import script from "./AddEditDocument.vue?vue&type=script&lang=js&"
export * from "./AddEditDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8c77aa",
  null
  
)

export default component.exports